"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInfiniteLoading = void 0;
const react_1 = require("react");
const lib_1 = require("./lib");
function useInfiniteLoading({ fetchingFn, initialData, pagination, }) {
    const [data, setData] = (0, react_1.useState)(initialData);
    const [currentPage, setCurrentPage] = (0, react_1.useState)(pagination.currentPage);
    const { itemsTotal, pageSize, withHighlightedStory } = pagination;
    const adjustedItemsTotal = withHighlightedStory ? itemsTotal - 1 : itemsTotal;
    const pagesTotal = Math.ceil(adjustedItemsTotal / pageSize);
    const canLoadMore = currentPage < pagesTotal;
    const [{ error, status }, { execute: loadMoreFn }] = (0, lib_1.useAsync)(async () => {
        const nextPage = currentPage + 1;
        const newData = await fetchingFn(nextPage, pageSize);
        setCurrentPage(nextPage);
        setData((currentData) => [...currentData, ...newData]);
    });
    const loadMore = (0, react_1.useCallback)(() => {
        if (canLoadMore) {
            loadMoreFn();
        }
    }, [canLoadMore, loadMoreFn]);
    const resetData = (0, react_1.useCallback)(() => {
        setData(initialData);
        setCurrentPage(pagination.currentPage);
    }, [pagination.currentPage, initialData]);
    (0, react_1.useEffect)(() => {
        if (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }, [error]);
    return {
        canLoadMore,
        currentPage,
        data,
        isLoading: status === 'loading',
        loadMore,
        resetData,
    };
}
exports.useInfiniteLoading = useInfiniteLoading;
//# sourceMappingURL=useInfiniteLoading.js.map